import './init';
import 'symbol-observable';
import '@formatjs/intl-displaynames/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { configureStore } from '@reduxjs/toolkit';
import { GlobalMenu } from '@tesla/design-system-react';
import { SiteFooter } from '@tesla/tw-react';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './store/reducers';
import rootSagas from './store/sagas';

import '@tesla/design-system-icons';
import '@tesla/design-system/dist/index.css';
import './styles/reset.css';

import createReducers from './shared/redux/reducers';
import Registry from './shared/redux/utils/registry';
import { registryMiddleware } from './shared/redux/middleware';

import App from './App';

const sagaMiddleware = createSagaMiddleware();

const renderApp = (externalContainer, baseRoute, externalProps) => {
  const initialReduxState = externalProps ? externalProps.initial_redux_state : {};
  const { loadingReducer, errorsReducer } = createReducers({
    loadingInitialState: null,
    errorsInitialState: null,
  });
  const initialReducers = {
    root: rootReducer,
    Data: (state = {}) => state,
    loading: loadingReducer,
    errors: errorsReducer,
  };
  // create middleware
  const middleware = [
    registryMiddleware(new Registry(initialReducers, sagaMiddleware)),
    sagaMiddleware,
    // logger,
  ];
  const { locale, showFooter } = initialReduxState.Data;
  // create store
  const store = configureStore({
    preloadedState: initialReduxState,
    reducer: initialReducers,
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(middleware),
  });
  sagaMiddleware.run(rootSagas);
  window.store = store;

  ReactDOM.render(
    <React.Fragment>
      <GlobalMenu locale={locale} disableLocaleSelectorAutoOpen />
      <App store={store} baseRoute={baseRoute} />
      {showFooter !== false ? <SiteFooter locale={locale} /> : null}
    </React.Fragment>,
    externalContainer
  );
};

export default renderApp;
